import { styled } from '@nexelem/deprecated-theme';

import { FC } from 'react';
import * as customIcons from './custom-icons';
import { IconComponentProps } from './IconTypes';

const IconWrapper = styled('button', {
  shouldForwardProp: (propName: string) => !['iconProps'].includes(propName),
})<Pick<IconComponentProps, 'onClick' | 'iconProps'>>(({ iconProps }) => {
  return {
    all: 'unset',
    outline: 'inherit',
    cursor: 'pointer',
    '> svg': {
      rotate: `${iconProps?.rotation || 0}deg`,
    },
  };
});

const RotateIcon = styled('div', {
  shouldForwardProp: (propName: string) => !['iconProps'].includes(propName),
})<Pick<IconComponentProps, 'iconProps'>>(({ iconProps }) => {
  if (iconProps) {
    return {
      display: 'flex',
      '> svg': {
        rotate: `${iconProps?.rotation ?? 0}deg`,
      },
    };
  }
  return {
    display: 'flex',
  };
});

type CustomIconsKeys = keyof typeof customIcons;

export const CUSTOM_ICONS: Record<CustomIconsKeys, FC<IconComponentProps>> = Object.freeze(
  Object.entries(customIcons).reduce(
    (acc, [key, Icon]) => {
      const newKey = key as CustomIconsKeys;
      acc[newKey] = ({ onClick, className, iconProps, ...props }: IconComponentProps) => {
        if (onClick) {
          return (
            <IconWrapper className={className} iconProps={iconProps} onClick={onClick}>
              <Icon {...props} />
            </IconWrapper>
          );
        }
        return (
          <RotateIcon iconProps={iconProps}>
            <Icon className={className} {...props} />
          </RotateIcon>
        );
      };
      return acc;
    },
    {} as Record<CustomIconsKeys, FC<IconComponentProps>>,
  ),
);
